import React from 'react';

// Styles & Assets
import styles from './ZonesBedManagementPage.module.css';

// Hooks
import { useState } from 'react';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import ZonesBedManagement from '../../components/ZonesBedManagementPage/ZonesBedManagement/ZonesBedManagement';

// Interfaces
import { Profile } from '../../interfaces/Profile';

// Language
import { useTranslation } from 'react-i18next';
import TopZoneManagement from '../../components/ZonesBedManagementPage/TopZoneManagement/TopZoneManagement';

// ZonesBedManagementPage: renders the toolbar, the input Select of the
// hospital and the service and also renders the ZonesBedManagment 
// component. Requests the hospital data and the department data to the api.
const ZonesBedManagementPage: React.FC = () => {

    const { t } = useTranslation();

    const [currentProfile, setCurrentProfile] = useState<Profile | null>(null);

    const [disableAssociation, setDisableAssociation] = useState(true);

    const handleDisableAssociation = (val: boolean) => setDisableAssociation(val);

    return (
        <div className={styles.container}>
            <Toolbar text={t('administration')} link='/home/administration' />
            <div className={styles.containerZonesBeds}>
                <h1 className={styles.title}>{t('zones_administration')}</h1>
                <TopZoneManagement
                    disableAssociation={disableAssociation}
                    profile={currentProfile}
                    setProfile={setCurrentProfile}
                />
                <ZonesBedManagement
                    profile={currentProfile}
                    handleDisableAssociation={handleDisableAssociation}
                />
            </div>
        </div>
    );
};

export default ZonesBedManagementPage;